<template>
  <div class="footer-config-management">
    <el-card>
      <div slot="header">
        <span>底部链接配置</span>
        <el-button style="float: right; padding: 3px 10px" type="primary" size="small" @click="showAddGroupDialog">
          添加分组
        </el-button>
      </div>
      
      <el-collapse v-model="activeGroups" v-loading="loading">
        <el-collapse-item v-for="group in groups" :key="group.id" :name="group.id">
          <template slot="title">
            <div class="group-header">
              <span class="group-title">{{ group.title }}</span>
              <div class="group-actions" @click.stop>
                <el-button-group>
                  <el-button size="mini" icon="el-icon-top" @click="moveGroupUp(group)" :disabled="isFirstGroup(group)"></el-button>
                  <el-button size="mini" icon="el-icon-bottom" @click="moveGroupDown(group)" :disabled="isLastGroup(group)"></el-button>
                </el-button-group>
                <el-button size="mini" @click="editGroup(group)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteGroup(group)">删除</el-button>
                <el-button size="mini" type="primary" @click="showAddLinkDialog(group)">添加链接</el-button>
              </div>
            </div>
          </template>
          
          <el-table :data="getGroupLinks(group.id)" style="width: 100%">
            <el-table-column label="排序" width="80">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" icon="el-icon-top" @click="moveLinkUp(group.id, scope.$index)" :disabled="scope.$index === 0"></el-button>
                  <el-button size="mini" icon="el-icon-bottom" @click="moveLinkDown(group.id, scope.$index)" :disabled="scope.$index === getGroupLinks(group.id).length - 1"></el-button>
                </el-button-group>
              </template>
            </el-table-column>
            <el-table-column prop="text" label="链接文本" width="200"></el-table-column>
            <el-table-column prop="url" label="链接地址"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button size="mini" @click="editLink(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteLink(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    
    <!-- 添加/编辑分组对话框 -->
    <el-dialog :title="groupDialogTitle" :visible.sync="groupDialogVisible" width="400px">
      <el-form :model="currentGroup" :rules="groupRules" ref="groupForm" label-width="100px">
        <el-form-item label="分组标题" prop="title">
          <el-input v-model="currentGroup.title" placeholder="请输入分组标题"></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveGroup">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 添加/编辑链接对话框 -->
    <el-dialog :title="linkDialogTitle" :visible.sync="linkDialogVisible" width="500px">
      <el-form :model="currentLink" :rules="linkRules" ref="linkForm" label-width="100px">
        <el-form-item label="链接文本" prop="text">
          <el-input v-model="currentLink.text" placeholder="请输入链接文本"></el-input>
        </el-form-item>
        
        <el-form-item label="链接地址" prop="url">
          <el-input v-model="currentLink.url" placeholder="请输入链接地址"></el-input>
        </el-form-item>
        
        <el-form-item label="图标类名">
          <el-input v-model="currentLink.icon" placeholder="可选，如：el-icon-phone"></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveLink">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FooterConfigManagement',
  data() {
    return {
      groups: [],
      linksMap: {},
      activeGroups: [],
      loading: false,
      
      groupDialogVisible: false,
      groupDialogTitle: '添加分组',
      currentGroup: {
        id: null,
        title: '',
        sortOrder: 0
      },
      groupRules: {
        title: [
          { required: true, message: '请输入分组标题', trigger: 'blur' }
        ]
      },
      
      linkDialogVisible: false,
      linkDialogTitle: '添加链接',
      currentLink: {
        id: null,
        groupId: null,
        text: '',
        url: '',
        icon: '',
        sortOrder: 0
      },
      linkRules: {
        text: [
          { required: true, message: '请输入链接文本', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入链接地址', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadFooterConfig()
  },
  methods: {
    async loadFooterConfig() {
      this.loading = true
      try {
        const response = await this.$http.get('/config/footer')
        if (response.success && response.data) {
          this.groups = response.data.groups || []
          this.linksMap = response.data.links || {}
          this.activeGroups = this.groups.map(g => g.id)
        }
      } catch (error) {
        this.$message.error('加载配置失败')
        console.error('加载配置失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    getGroupLinks(groupId) {
      return this.linksMap[groupId] || []
    },
    
    isFirstGroup(group) {
      return this.groups.indexOf(group) === 0
    },
    
    isLastGroup(group) {
      return this.groups.indexOf(group) === this.groups.length - 1
    },
    
    // ==================== 分组管理 ====================
    
    showAddGroupDialog() {
      this.groupDialogTitle = '添加分组'
      this.currentGroup = {
        id: null,
        title: '',
        sortOrder: this.groups.length
      }
      this.groupDialogVisible = true
      this.$nextTick(() => {
        this.$refs.groupForm && this.$refs.groupForm.clearValidate()
      })
    },
    
    editGroup(group) {
      this.groupDialogTitle = '编辑分组'
      this.currentGroup = { ...group }
      this.groupDialogVisible = true
      this.$nextTick(() => {
        this.$refs.groupForm && this.$refs.groupForm.clearValidate()
      })
    },
    
    saveGroup() {
      this.$refs.groupForm.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.currentGroup.id) {
              response = await this.$http.put(`/config/footer/group/${this.currentGroup.id}`, this.currentGroup)
            } else {
              response = await this.$http.post('/config/footer/group', this.currentGroup)
            }
            
            if (response.success) {
              this.$message.success(this.currentGroup.id ? '分组更新成功' : '分组添加成功')
              this.groupDialogVisible = false
              this.loadFooterConfig()
            }
          } catch (error) {
            this.$message.error('操作失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
          }
        }
      })
    },
    
    deleteGroup(group) {
      this.$confirm(`确定要删除分组"${group.title}"吗？这将同时删除该分组下的所有链接。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.delete(`/config/footer/group/${group.id}`)
          if (response.success) {
            this.$message.success('删除成功')
            this.loadFooterConfig()
          }
        } catch (error) {
          this.$message.error('删除失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
        }
      }).catch(() => {})
    },
    
    async moveGroupUp(group) {
      const index = this.groups.indexOf(group)
      if (index === 0) return
      const temp = this.groups[index]
      this.groups[index] = this.groups[index - 1]
      this.groups[index - 1] = temp
      await this.updateGroupOrder()
    },
    
    async moveGroupDown(group) {
      const index = this.groups.indexOf(group)
      if (index === this.groups.length - 1) return
      const temp = this.groups[index]
      this.groups[index] = this.groups[index + 1]
      this.groups[index + 1] = temp
      await this.updateGroupOrder()
    },
    
    async updateGroupOrder() {
      this.groups.forEach((group, index) => {
        group.sortOrder = index
      })
      
      for (const group of this.groups) {
        try {
          await this.$http.put(`/config/footer/group/${group.id}`, group)
        } catch (error) {
          console.error('更新分组顺序失败:', error)
        }
      }
      this.$message.success('顺序更新成功')
    },
    
    // ==================== 链接管理 ====================
    
    showAddLinkDialog(group) {
      this.linkDialogTitle = '添加链接'
      const links = this.getGroupLinks(group.id)
      this.currentLink = {
        id: null,
        groupId: group.id,
        text: '',
        url: '',
        icon: '',
        sortOrder: links.length
      }
      this.linkDialogVisible = true
      this.$nextTick(() => {
        this.$refs.linkForm && this.$refs.linkForm.clearValidate()
      })
    },
    
    editLink(link) {
      this.linkDialogTitle = '编辑链接'
      this.currentLink = { ...link }
      this.linkDialogVisible = true
      this.$nextTick(() => {
        this.$refs.linkForm && this.$refs.linkForm.clearValidate()
      })
    },
    
    saveLink() {
      this.$refs.linkForm.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.currentLink.id) {
              response = await this.$http.put(`/config/footer/link/${this.currentLink.id}`, this.currentLink)
            } else {
              response = await this.$http.post('/config/footer/link', this.currentLink)
            }
            
            if (response.success) {
              this.$message.success(this.currentLink.id ? '链接更新成功' : '链接添加成功')
              this.linkDialogVisible = false
              this.loadFooterConfig()
            }
          } catch (error) {
            this.$message.error('操作失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
          }
        }
      })
    },
    
    deleteLink(link) {
      this.$confirm(`确定要删除链接"${link.text}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.delete(`/config/footer/link/${link.id}`)
          if (response.success) {
            this.$message.success('删除成功')
            this.loadFooterConfig()
          }
        } catch (error) {
          this.$message.error('删除失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
        }
      }).catch(() => {})
    },
    
    async moveLinkUp(groupId, index) {
      const links = this.linksMap[groupId]
      if (index === 0) return
      const temp = links[index]
      links[index] = links[index - 1]
      links[index - 1] = temp
      await this.updateLinkOrder(groupId)
    },
    
    async moveLinkDown(groupId, index) {
      const links = this.linksMap[groupId]
      if (index === links.length - 1) return
      const temp = links[index]
      links[index] = links[index + 1]
      links[index + 1] = temp
      await this.updateLinkOrder(groupId)
    },
    
    async updateLinkOrder(groupId) {
      const links = this.linksMap[groupId]
      links.forEach((link, index) => {
        link.sortOrder = index
      })
      
      for (const link of links) {
        try {
          await this.$http.put(`/config/footer/link/${link.id}`, link)
        } catch (error) {
          console.error('更新链接顺序失败:', error)
        }
      }
      this.$message.success('顺序更新成功')
    }
  }
}
</script>

<style scoped>
.footer-config-management {
  max-width: 1200px;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 20px;
}

.group-title {
  font-weight: bold;
  font-size: 16px;
}

.group-actions {
  display: flex;
  gap: 10px;
}
</style>
